import template from './leave_types_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class LeaveTypesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class LeaveTypesHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new LeaveTypesHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'LeaveTypesHelp',
	dialog_class: LeaveTypesHelpPage,
	template: template,
	template_filename: 'translation/dialogs/leave_types_help',
	provider: 'ps'
};
